import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import useBreadcrumbs from 'use-react-router-breadcrumbs';
import { CAMS_CARE_URL, USER_ROLES } from '../../../constants';

const BreadCrumbRouter = ({ routes, role = USER_ROLES.SUBSCRIBER }) => {
     let currentLocation = useLocation().pathname;

     const lastCharCurrent = currentLocation.slice(-1);
     const excludePaths = [];

     const breadcrumbs = useBreadcrumbs(routes, { excludePaths, disableDefaults: true });

     if (lastCharCurrent === '/') {
          currentLocation = currentLocation.slice(0, -1);
     }

     if (currentLocation === '/checkout/payment-success') {
          const brIndex = breadcrumbs.indexOf(breadcrumbs.find((br) => br.key === '/checkout'));
          breadcrumbs.splice(brIndex, 1);
     }

     const BreadcrumbItem = ({ pathName = '', breadcrumb, checkActiveSlug }) => {
          if (pathName !== '/') {
               pathName = pathName + '/';
          }

          return (
               <span
                    className={`breadcrumb-custom-item${checkActiveSlug ? ' active' : ''}`}
                    onClick={(e) => {
                         e.stopPropagation();
                    }}
               >
                    {checkActiveSlug ? (
                         <>{breadcrumb}</>
                    ) : pathName === '/' && role !== USER_ROLES.SYSTEM_ADMIN ? (
                         <a href={CAMS_CARE_URL}>{breadcrumb}</a>
                    ) : (
                         <Link to={pathName}>{breadcrumb}</Link>
                    )}
               </span>
          );
     };

     return (
          <div className="breadcrumb-custom">
               {!breadcrumbs.length && <BreadcrumbItem breadcrumb="Dashboard" checkActiveSlug />}

               {breadcrumbs.length > 0 && breadcrumbs[0].match?.pathname === '/' && (
                    <BreadcrumbItem
                         pathName="/"
                         breadcrumb={routes.find((route) => route.path === '/')?.breadcrumb}
                         checkActiveSlug={breadcrumbs.length <= 1}
                    />
               )}
               {breadcrumbs.map(({ match, breadcrumb }) => {
                    if (match.pathnameBase === '/') {
                         return null;
                    }

                    const checkActiveSlug = match.pathname === currentLocation;
                    return (
                         <BreadcrumbItem key={match.pathname} pathName={match.pathname} breadcrumb={breadcrumb} checkActiveSlug={checkActiveSlug} />
                    );
               })}
          </div>
     );
};

BreadCrumbRouter.propTypes = {
     routes: PropTypes.array,
};

export default React.memo(BreadCrumbRouter);
